import React from 'react';
import { useIntl } from 'react-intl';

import Grid from '@/components/Grid/Grid';
import PageNext from '@/components/Page/PageNext';
import RegisterCompanyForm from '@/components/Register/RegisterCompanyForm';
import { NextPage } from '@/pages/_app';

const RegisterCompanyPage: NextPage = () => {
  const intl = useIntl();
  return (
    <PageNext title={intl.formatMessage({ id: 'app.register.company.pagetitle' })}>
      <div className="geecko-registerform-container">
        <Grid container fullHeight alignContent="center" alignItems="center" justify="center">
          <Grid item xs={12}>
            <div style={{ maxWidth: 948, padding: 16, margin: '0 auto' }}>
              <RegisterCompanyForm />
            </div>
          </Grid>
        </Grid>
      </div>
    </PageNext>
  );
};

RegisterCompanyPage.accessGroups = 'public';

export default RegisterCompanyPage;
